import classNames from 'classnames';
import React from 'react';
import { Tooltip } from '@arco-design/web-react';
import { TooltipHandle } from '@arco-design/web-react/es/Tooltip';

import styles from './index.module.less';
import { IBaseTooltipV2 } from './interface';
import { BuildInButton } from './BuildInButton';

export const BaseTooltipV2 = React.forwardRef<TooltipHandle, IBaseTooltipV2>((props, ref) => {
	const { className, light, triggerProps, content, buttonText, ...rest } = props;

	const mergedClass = classNames(className, styles.tooltip, {
		[styles.light]: light,
	});

	const mergedTriggerProps = {
		mouseEnterDelay: 300,
		mouseLeaveDelay: 0,
		...triggerProps,
	};

	return (
		<Tooltip
			ref={ref}
			className={mergedClass}
			triggerProps={mergedTriggerProps}
			content={
				buttonText ? (
					<div className={styles.tooltips_content}>
						{content} <BuildInButton light={light}>{buttonText}</BuildInButton>
					</div>
				) : (
					content
				)
			}
			{...rest}
		/>
	);
});
